import { useState, useCallback } from 'react'
import { isRecordingSessionActive } from 'src/live'
import { recordingService } from '../services/recordingService'

export const useSessionRecording = () => {
  const [isSessionRecording, setIsSessionRecording] = useState(false)
  const [isRecordingProcessWaiting, setIsRecordingProcessWaiting] = useState(false)

  const queryRecordingStatus = useCallback(async (bookedEventFinalData, uidObject) => {
    if (!isSessionRecording || !bookedEventFinalData?.id) {
      return
    }

    const response = await recordingService.queryRecordingStatus(
      bookedEventFinalData?.id,
      uidObject?.recordingResourceId,
      uidObject?.recordingSid,
      {
        uidRecording: uidObject?.uidRecording,
        recordingProvider:
          bookedEventFinalData?.sessionRoutingDecision?.recordingProvider ||
          bookedEventFinalData?.recordingProvider,
      },
    )

    if (!response?.success || !isRecordingSessionActive(response?.recordingSession)) {
      setIsSessionRecording(false)
    }
  }, [isSessionRecording])

  const handleRecordingButtonClick = useCallback(async (bookedEventFinalData, uidObject, setUidObject) => {
    setIsRecordingProcessWaiting(true)

    if (!isSessionRecording) {
      const response = await recordingService.startRecording(
        bookedEventFinalData?.id,
        uidObject?.uidRecording,
        {
          recordingProvider:
            bookedEventFinalData?.sessionRoutingDecision?.recordingProvider ||
            bookedEventFinalData?.recordingProvider,
        },
      )

      if (response?.success) {
        setUidObject((prev) => ({
          ...prev,
          recordingResourceId: response?.resourceId,
          recordingSid: response?.sid,
        }))

        const statusResponse = await recordingService.queryRecordingStatus(
          bookedEventFinalData?.id,
          response?.resourceId,
          response?.sid,
          {
            uidRecording: uidObject?.uidRecording,
            recordingProvider:
              bookedEventFinalData?.sessionRoutingDecision?.recordingProvider ||
              bookedEventFinalData?.recordingProvider,
          },
        )

        setIsSessionRecording(isRecordingSessionActive(statusResponse?.recordingSession))
      }
    } else {
      await recordingService.stopRecording(
        bookedEventFinalData?.id,
        uidObject?.uidRecording,
        uidObject?.recordingResourceId,
        uidObject?.recordingSid,
        {
          recordingProvider:
            bookedEventFinalData?.sessionRoutingDecision?.recordingProvider ||
            bookedEventFinalData?.recordingProvider,
        },
      )
      setIsSessionRecording(false)
    }

    setIsRecordingProcessWaiting(false)
  }, [isSessionRecording])

  return {
    isSessionRecording,
    setIsSessionRecording,
    isRecordingProcessWaiting,
    setIsRecordingProcessWaiting,
    queryRecordingStatus,
    handleRecordingButtonClick,
  }
}
